import naja from "naja";
import Form from "./Form";
import SlimSelect from "slim-select";


export default class ProductGrid {
    static init() {
        const grid = document.getElementById('jsProductGrid');
        const trigger = document.getElementById('jsProductGridShowAll');

        if (trigger && grid) {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                grid.classList.toggle('product-grid--open');
                trigger.classList.toggle('link--product-grid-open');
            });
        }
        this.initInputs();
        this.handleSeriesRefresh();
        this.handleSeriesSelect();
        this.handleBrandSelect();
        this.handlePrinterSelect();
        this.handlePrintersRefresh();
    }

    static initInputs() {
        const inputs = document.querySelectorAll('.product-grid__input');

        if (inputs.length > 0) {
            inputs.forEach(input => {
                input.addEventListener('click', e => {
                    naja.makeRequest('GET', input.dataset.href, null, {
                        history: false
                    });
                });
            });
        }
    }

    static handleBrandSelect() {
        const select = document.querySelector('#jsProductBrand');
        if(select) {
            select.addEventListener('change', e => {
                const selectedOption = select.options[select.selectedIndex];
                naja.makeRequest('GET', selectedOption.dataset.href, null, {
                    history: false
                });
            })
        }
    }


    static handleSeriesSelect() {
        const select = document.querySelector('#jsProductSeries');
        if(select) {
            select.addEventListener('change', e => {
                const selectedOption = select.options[select.selectedIndex];
                naja.makeRequest('GET', selectedOption.dataset.href, null, {
                    history: false
                });
            })
        }
    }

    static handlePrinterSelect() {
        const select = document.querySelector('#jsProductPrinter');
        if(select) {
            select.addEventListener('change', e => {
                const selectedOption = select.options[select.selectedIndex];
                naja.makeRequest('GET', select.dataset.href +'&productSelector-id='+ selectedOption.value, null, {
                    history: false
                });
            })
        }
    }

    static handleSeriesRefresh() {
        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet-productSelector-tonGroups') {
                const productSeries = new SlimSelect({
                    select: '#jsProductSeries',
                    searchPlaceholder: 'Vyhledávání',
                    showContent: 'down'
                });
                this.handleSeriesSelect();
            }
        });
    }

    static handlePrintersRefresh() {
        naja.snippetHandler.addEventListener('afterUpdate', (event) => {
            if (event.detail.snippet.id === 'snippet-productSelector-tonPrinters') {
                const productSeries = new SlimSelect({
                    select: '#jsProductPrinter',
                    searchPlaceholder: 'Vyhledávání',
                    showContent: 'down'
                });

                this.handlePrinterSelect();
            }
        });
    }
}
